import axios from 'axios'

const http = axios.create({
	// baseURL: window.web_config.api_url,
  baseURL: window.web_config.api_url,
	timeout: 60000
})
http.interceptors.request.use(
	config => {
		let uinfoStr = window.localStorage.getItem('tokenInfo')
		if (uinfoStr) {
			let uinfo = JSON.parse(uinfoStr)
			config.headers.Authorization = `Bearer ${uinfo.access_token}`
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
http.interceptors.response.use(
	({ data }) => {
		return data
	},
  error => {
    if (error.response?.data?.error_code && error.response.data.error_msg) {
      return Promise.reject(error.response.data.error_msg)
    }
		return Promise.reject(error.response || error)
	}
)
export default http
